import { ApprovalWorkflowItemDto } from '@api/Api';
import ApprovalListSkeleton from '@components/Approval/ApprovalListSkeleton';
import React, { memo } from 'react';
import ApprovalItem from '@pages/Dashboard/components/ApprovalsCard/ApprovalItem';
import ApprovalEmptyStateWrapper from '@components/Approval/ApprovalEmptyStateWrapper/ApprovalEmptyStateWrapper';

type ApprovalListProps = {
  isLoading: boolean;
  list: ApprovalWorkflowItemDto[] | undefined;
  refetchApprovalsData: () => void;
};

export default memo(function ApprovalsList({
  list,
  isLoading,
  refetchApprovalsData
}: ApprovalListProps) {
  if (!list || isLoading) return <ApprovalListSkeleton />;
  return (
    <ApprovalEmptyStateWrapper
      listLength={list.length}
      refetchApprovalsData={refetchApprovalsData}
    >
      <>
        {list.map((it) => {
          return <ApprovalItem key={it.id} approvalWorkflow={it} />;
        })}
      </>
    </ApprovalEmptyStateWrapper>
  );
});
